import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ItemForm } from "types";

export interface ItemFormState {
  value: ItemForm;
}

const initialState: ItemFormState = {
  value: {
    isNewItemMode: false,
    isEditItemMode: false,
    itemToEditId: null,
  },
};

const itemFormSlice = createSlice({
  name: "itemForm",
  initialState,
  reducers: {
    enableNewItemMode(state) {
      state.value.isNewItemMode = true;
    },
    closeItemForm(state) {
      state.value.isNewItemMode = false;
      state.value.isEditItemMode = false;
      state.value.itemToEditId = null;
    },
    enableEditItemMode(state, action: PayloadAction<string>) {
      state.value.isEditItemMode = true;
      state.value.itemToEditId = action.payload;
    },
  },
});

export const { enableNewItemMode, closeItemForm, enableEditItemMode } =
  itemFormSlice.actions;
export default itemFormSlice.reducer;
